module.exports = __webpack_public_path__ + "static/img/app-logo.f90a2736.png";